import i18n from "../../src/lang/index.js";

function indexData(index, dayCount) {
  var data = {};
  if (index == 0) {
    //周
    data.xData = [
      i18n.t("machine.record2")[1],
      i18n.t("machine.record2")[2],
      i18n.t("machine.record2")[3],
      i18n.t("machine.record2")[4],
      i18n.t("machine.record2")[5],
      i18n.t("machine.record2")[6],
      i18n.t("machine.record2")[0]
    ];
  } else if (index == 1) {
    //月
    var xData = [];
    for (var i = 1; i <= dayCount; i++) {
      xData.push(i);
    }
    data.xData = xData;
  } else {
    //年
    data.xData = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  }
  return data;
}

function dayX(list) {
  if (list.length != 0 && list.xvalues.length > 0) {
    return list.xvalues;
  } else {
    return ["00:00"];
  }
}

//范围值颜色
function getColor(normal, color) {
  if (normal == 1) {
    return "#FF0000";
  } else if (normal == 4) {
    return "#FF9D1F";
  } else if (normal == 6) {
    return "#C20000";
  } else if (normal == 7) {
    return "#7F00C1";
  } else if (normal == 2 || normal == 3) {
    return color;
  }
}

//血压心率
export function hrbpOption(index, list) {
  var dayCount = index == 1 ? list.hr.length : 0;
  var option = {
    animation: false,
    color: ["#59A3DC", "#F7AE12", "#0AD280"],
    grid: {
      left: "0",
      right: "0",
      bottom: "10",
      top: "10",
      containLabel: true
    },
    xAxis: {
      type: "category",
      axisTick: {
        // 坐标轴小标记
        show: false
      },
      axisLine: {
        //x轴线
        lineStyle: {
          color: "#000000",
          opacity: 0.15
        }
      },
      axisLabel: {
        //x轴文字
        color: "#666666",
        padding: [5, 0, 0, 0]
      },
      data: index == 3 ? dayX(list) : indexData(index, dayCount).xData
    },
    yAxis: {
      type: "value",
      position: "right",
      axisTick: {
        // 坐标轴小标记
        show: false
      },
      axisLine: {
        //y轴线
        show: false
      },
      axisLabel: {
        //x轴文字
        color: "#666666"
      },
      max: 200,
      interval: 50
    },
    series: [
      {
        type: "line",
        symbol: "circle",
        symbolSize: 8,
        itemStyle: {
          color: function(params) {
            return getColor(list.sbpNormal[params.dataIndex], "#59A3DC");
          }
        },
        data: list.sbp
      },
      {
        type: "line",
        symbol: "circle",
        symbolSize: 8,
        itemStyle: {
          color: function(params) {
            return getColor(list.dbpNormal[params.dataIndex], "#F7AE12");
          }
        },
        data: list.dbp
      },
      {
        type: "line",
        symbol: "circle",
        symbolSize: 8,
        itemStyle: {
          color: function(params) {
            return getColor(list.hrNormal[params.dataIndex], "#0AD280");
          }
        },
        data: list.hr
      }
    ]
  };
  return option;
}

//血脂
export function bloodFatOption(index, list) {
  var dayCount = index == 1 ? list.chol.length : 0;
  var option = {
    animation: false,
    color: ["#01ECC2", "#C66F22", "#DC51ED", "#3970EC"],
    grid: {
      left: "0",
      right: "0",
      bottom: "10",
      top: "10",
      containLabel: true
    },
    xAxis: {
      type: "category",
      axisTick: {
        // 坐标轴小标记
        show: false
      },
      axisLine: {
        //x轴线
        lineStyle: {
          color: "#000000",
          opacity: 0.15
        }
      },
      axisLabel: {
        //x轴文字
        color: "#666666",
        padding: [5, 0, 0, 0]
      },
      data: index == 3 ? dayX(list) : indexData(index, dayCount).xData
    },
    yAxis: {
      type: "value",
      position: "right",
      axisTick: {
        // 坐标轴小标记
        show: false
      },
      axisLine: {
        //y轴线
        show: false
      },
      axisLabel: {
        //x轴文字
        color: "#666666"
      },
      max: 12,
      interval: 3
    },
    series: [
      {
        type: "line",
        symbol: "circle",
        symbolSize: 8,
        itemStyle: {
          color: function(params) {
            return getColor(list.cholNormal[params.dataIndex], "#01ECC2");
          }
        },
        data: list.chol
      },
      {
        type: "line",
        symbol: "circle",
        symbolSize: 8,
        itemStyle: {
          color: function(params) {
            return getColor(list.tgNormal[params.dataIndex], "#C66F22");
          }
        },
        data: list.tg
      },
      {
        type: "line",
        symbol: "circle",
        symbolSize: 8,
        itemStyle: {
          color: function(params) {
            return getColor(list.ldlcNormal[params.dataIndex], "#DC51ED");
          }
        },
        data: list.ldlc
      },
      {
        type: "line",
        symbol: "circle",
        symbolSize: 8,
        itemStyle: {
          color: function(params) {
            return getColor(list.hdlcNormal[params.dataIndex], "#3970EC");
          }
        },
        data: list.hdlc
      }
    ]
  };
  return option;
}

//血糖
export function gluOption(index, list) {
  var dayCount = index == 1 ? list.glu_0.length : 0;
  var option = {
    animation: false,
    color: ["#51D9ED", "#5997DC"],
    grid: {
      left: "0",
      right: "0",
      bottom: "10",
      top: "10",
      containLabel: true
    },
    xAxis: {
      type: "category",
      axisTick: {
        // 坐标轴小标记
        show: false
      },
      axisLine: {
        //x轴线
        lineStyle: {
          color: "#000000",
          opacity: 0.15
        }
      },
      axisLabel: {
        //x轴文字
        color: "#666666",
        padding: [5, 0, 0, 0]
      },
      data: index == 3 ? dayX(list) : indexData(index, dayCount).xData
    },
    yAxis: {
      type: "value",
      position: "right",
      axisTick: {
        // 坐标轴小标记
        show: false
      },
      axisLine: {
        //y轴线
        show: false
      },
      axisLabel: {
        //x轴文字
        color: "#666666"
      },
      max: 12,
      interval: 3
    },
    series: [
      {
        type: "line",
        symbol: "circle",
        symbolSize: 8,
        itemStyle: {
          color: function(params) {
            return getColor(list.glu0Normal[params.dataIndex], "#51D9ED");
          }
        },
        data: index == 3 ? getGluOption(list.glu_0) : list.glu_0,
        connectNulls: index == 3 ? false : true
      },
      {
        type: "line",
        symbol: "circle",
        symbolSize: 8,
        itemStyle: {
          color: function(params) {
            return getColor(list.glu1Normal[params.dataIndex], "#5997DC");
          }
        },
        data: index == 3 ? getGluOption(list.glu_1) : list.glu_1,
        connectNulls: index == 3 ? false : true
      }
    ]
  };
  return option;
}
// 血糖值处理
function getGluOption(value) {
  var arr = [];
  for (var i = 0; i < value.length; i++) {
    if (value[i] <= 0) {
      arr[i] = "";
    } else {
      arr[i] = value[i];
    }
  }
  return arr;
}

//尿酸
export function uricAcidOption(index, list) {
  var dayCount = index == 1 ? list.uricAcid.length : 0;
  var option = {
    animation: false,
    color: ["#3970EC"],
    grid: {
      left: "0",
      right: "0",
      bottom: "10",
      top: "10",
      containLabel: true
    },
    xAxis: {
      type: "category",
      axisTick: {
        // 坐标轴小标记
        show: false
      },
      axisLine: {
        //x轴线
        lineStyle: {
          color: "#000000",
          opacity: 0.15
        }
      },
      axisLabel: {
        //x轴文字
        color: "#666666",
        padding: [5, 0, 0, 0]
      },
      data: index == 3 ? dayX(list) : indexData(index, dayCount).xData
    },
    yAxis: {
      type: "value",
      position: "right",
      axisTick: {
        // 坐标轴小标记
        show: false
      },
      axisLine: {
        //y轴线
        show: false
      },
      axisLabel: {
        //x轴文字
        color: "#666666"
      },
      max: 600,
      interval: 150
    },
    series: [
      {
        type: "line",
        symbol: "circle",
        symbolSize: 8,
        itemStyle: {
          color: function(params) {
            return getColor(list.uaNormal[params.dataIndex], "#3970EC");
          }
        },
        data: list.uricAcid
      }
    ]
  };
  return option;
}

// 小白手表
export function sleepOption(list) {
  var option = {
    animation: false,
    series: {
      type: "pie",
      radius: ["60%", "100%"],
      hoverAnimation: false,
      itemStyle: {
        borderRadius: 5,
        borderColor: "#fff",
        borderWidth: 2
      },
      labelLine: {
        show: false
      },
      data: [
        {
          value: list.sleep.deep,
          itemStyle: {
            color: "#9031EF"
          }
        },
        {
          value: list.sleep.light,
          itemStyle: {
            color: "#CD47EE"
          }
        },
        {
          value: list.sleep.rem,
          itemStyle: {
            color: "#FC7B3A"
          }
        },
        {
          value: list.sleep.awake,
          itemStyle: {
            color: "#F3C200"
          }
        }
      ]
    }
  };
  return option;
}



//////////////////
// WEBPACK FOOTER
// ./static/js/echarts.js
// module id = null
// module chunks = 